


























































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { bookingModule, authModule } from '@/store';
import { AnonEmail } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;

  verifyEmail: AnonEmail | null = null;
  emailError: string = '';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Email address required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email address must be valid',
  ];

  get titles() {
    if (!bookingModule.titles) {
      return;
    }
    return bookingModule.titles;
  }

  get booking() {
    if (!bookingModule.booking) {
      return;
    }
    return bookingModule.booking;
  }

  get customer() {
    if (!authModule.user || !this.booking) {
      return;
    }
    this.booking.customer = authModule.user.customer;
    return authModule.user.customer;
  }

  login() {
    authModule.openLoginDialog({ cb: null });
  }

  register() {
    authModule.openLoginDialog({ cb: null, tab: 1 });
  }

  bookingBack() {
    this.$router.back();
  }

  async step2() {
    if (!this.booking) {
      return;
    }

    try {
      this.loading = true;

      if (this.booking.customer) {
        await this.booking.customer.save();
      } else {
        const encodedEmail = encodeURIComponent(this.booking.email);
        this.verifyEmail = (await AnonEmail.find(encodedEmail)).data;
        if (!this.verifyEmail.anon) {
          this.emailError =
            'This email address belongs to a user, please log in to continue.';
          throw new Error('Email address belongs to a user.');
        }
      }

      bookingModule.setCompletedStep(2);
      this.$router.push({
        name: 'booking-step-3',
      });
    } catch (err) {
      // Error
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    bookingModule.setCurrentStep(2);
    bookingModule.checkStatus();
  }

  @Watch('booking.email')
  @Watch('booking.customer')
  clearEmailError() {
    this.emailError = '';
  }
}
